class Omnibus extends HTMLElement {
  connectedCallback() {
    this.eventRoot = this.closest('product-info') || this.closest('[data-section-id]');
    this.priceElements = this.querySelectorAll('[data-prices-variant-id]');

    if (!this.eventRoot || !this.priceElements.length) {
      return;
    }

    this.onVariantChange = (event) => this.updateVisibility(event.detail?.variant?.id);

    this.eventRoot.addEventListener('variant:change', this.onVariantChange);
  }

  disconnectedCallback() {
    this.eventRoot?.removeEventListener('variant:change', this.onVariantChange);
  }

  updateVisibility(variantId) {
    if (!variantId) {
      return;
    }

    this.priceElements.forEach((element) => {
      const priceVariantId = element.dataset.pricesVariantId;
      element.hidden = String(variantId) !== String(priceVariantId);
    });
  }
}

if (!customElements.get('omnibus-element')) {
  customElements.define('omnibus-element', Omnibus);
}
